// row 110 FieldState: the 12 px pill on a field's label (Field's labelSlot). Parsing: *Proposed* (info) until the user
// edits or ticks the value, then *Confirmed* (ok). The framework: *Suggested* (info) until HM or Recruiter edits it,
// then *Customized* (ok). The flip is the host's: it passes `done` once the value was edited or ticked.

import { Pill } from "../core/Pill";
import { cx } from "../lib/cx";
import { G1_LABELS } from "./labels";

export interface FieldStateProps {
  /** "parsing": Proposed → Confirmed (a parsed resume). "framework": Suggested → Customized (the level framework). */
  kind: "parsing" | "framework";
  /** The value was edited or ticked. */
  done?: boolean | undefined;
  className?: string | undefined;
}

const WORDS = {
  parsing: [G1_LABELS.proposed, G1_LABELS.confirmed],
  framework: [G1_LABELS.suggested, G1_LABELS.customized],
} as const;

export function FieldState({ kind, done = false, className }: FieldStateProps) {
  const [before, after] = WORDS[kind];
  return (
    <Pill tone={done ? "ok" : "info"} dot={false} className={cx("mc-fl-state", className)}>
      {done ? after : before}
    </Pill>
  );
}
